import {
  IUserLegalInfoFieldsState,
  IUserLegalInfoFormFields,
} from '../UserLegalInfoFields.types';

export const convertFieldsToObject = (
  fields: IUserLegalInfoFieldsState[],
): IUserLegalInfoFormFields => {
  return fields.reduce((acc, field) => {
    acc[field.name as keyof IUserLegalInfoFormFields] = field.value;
    return acc;
  }, {} as IUserLegalInfoFormFields);
};
